<template>
  <div class="page-container">
    <div class="filter-container">
      <el-form size="small" :inline="true"  @submit.native.prevent>
        <el-form-item :label="item.label" v-for="item in orderFilter" :key="item.label" size="small">
          <el-date-picker
            type="datetimerange"
            v-if="item.type === 'datetimerange'"
            v-model="form[item.start + '_' + item.end]"
            :default-time="['00:00:00', '23:59:59']"
            value-format="timestamp"
          ></el-date-picker>
          <el-cascader style="background-color: #222933;"
                       v-else-if="item.optionsName==='diseaseNamesOptions'"
                       v-model="form[item.prop]"
                       :options="options[item.optionsName]"
                       :props="{ multiple: true,value:'id',label:'name' }"
                       collapse-tags
                       filterable></el-cascader>
          <el-select v-else-if="item.optionsName" v-model="form[item.prop]" clearable="clearable">
            <el-option
              v-for="option in options[item.optionsName]"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            ></el-option>
          </el-select>
          <!-- 根据item.options显示下拉框 -->
          <el-select v-else-if="item.options" v-model="form[item.prop]" clearable="clearable">
            <el-option
              v-for="option in item.options"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            ></el-option>
          </el-select>
          <el-input v-else v-model="form[item.prop]" @keyup.enter.native="onSearch"></el-input>
        </el-form-item>
        <div class="btn-container">
          <el-dropdown>
            <el-button size="small" type="primary" @click="sortType=1;onSearch()">查询<i class="el-icon-arrow-down el-icon--right"></i></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="sortType=2;onSearch()">按创建时间排序</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button size="small" @click="onReset">清除</el-button>
          <el-button size="small" v-if="showExport" type="primary" @click="onExportShow">导出</el-button>
        </div>
      </el-form>
    </div>
    <div class="table-container">
      <el-table stripe="stripe" :data="tableData" size="small">
        <el-table-column v-if="item.prop" :label="item.label" v-for="item in orderTable" :key="item.label"
                         :width="columWidth(item.prop) || ''">
          <template slot-scope="{ row , $index}">
            <el-link v-if="item.prop === 'publicOrderId'" @click="onClickOrderSn(row)"  :style="{color:['#FFFFFF','#AAAAAA'][$index%2]}">
              {{columText(row,item)}}
            </el-link>
            <span v-else-if="item.prop === 'payStatus'">
               <el-tooltip class="item" effect="dark" :content="columText(row,item,1)" placement="top">
                <i class="el-icon-full-screen"  style="color: #444" v-if="row.payStatus===0"/>
                <i class="el-icon-check" style="color: green"  v-else-if="row.payStatus===1"/>  <!--1:现金支付 -->
                <i class="el-icon-close" style="color: red"   v-else-if="row.payStatus===2"/>   <!--2:已退款 -->
                <i class="el-icon-minus" v-else/>
               </el-tooltip>
               <el-tooltip class="item" effect="dark" :content="columText(row,item,2)" placement="top">
                <i class="el-icon-full-screen"   style="color: #444" v-if="row.agentPayStatus===0"/>
                <i class="el-icon-check"  style="color: yellow" v-else-if="row.agentPayStatus===1"/> <!--1:现金支付 -->
                <i class="el-icon-close"  style="color: red"    v-else-if="row.agentPayStatus===2"/> <!--2:已退款 -->
                <i class="el-icon-key"    style="color: yellow" v-else-if="row.agentPayStatus===3"/> <!--3:代金券支付 -->
                <i class="el-icon-loading" style="color: red"   v-else-if="row.agentPayStatus===4"/> <!--4:申请退款中 -->
                <i class="el-icon-minus" v-else/>
               </el-tooltip>
              </span>
            <span v-else-if="item.prop === 'status'">
               <el-tooltip class="item" effect="dark" :content="columText(row,item)" placement="top">
                <i class="el-icon-position" style="color: yellow" v-if="columText(row,item)==='待提交'"/>
                <i class="el-icon-bell" style="color: red"  v-else-if="columText(row,item)==='已提交'"/>
                <i class="el-icon-loading" v-else-if="columText(row,item)==='处理中'"/>
                <i class="el-icon-finished" style="color: green"  v-else-if="columText(row,item)==='已完成'"/>
                <span v-else>columText(row,item)</span>
               </el-tooltip>
            </span>
            <el-link v-else-if="item.prop === 'patientName'" style="color: white">
              <el-tag @click="onClickOrderSn(row)" :color="row.publicOrderId==''?'#491d1d':'#1e3546'"><span style="color: white">{{columText(row,item)}}</span></el-tag>
            </el-link>
            <span v-else-if="item.prop === 'invoice'">
              <i class="el-icon-message" style="color: green"  circle v-if="columText(row,item)==='是'"/>
            </span>
            <span v-else >
              {{columText(row,item)}}
            </span>
            <div v-if="item.prop === 'publicOrderId' && (isAdmin || isCaptain || isWorker)">
              <span v-if="row.processor">
                <i class="el-icon-s-custom"></i>
                <el-tooltip v-for="tag in workerTags(row.processor)"  :key="tag.name" :content="tag.tip"
                            class="item" effect="dark" placement="top" >
                  <el-tag size="mini" type="info" style="margin-right: 5px;"  effect="dark">
                    {{tag.name}}
                  </el-tag>
                </el-tooltip>

              </span>
<!--              <el-divider v-if="row.tags && row.processor" direction="vertical"/>-->
              <div v-if="row.tags && row.processor" />
              <span v-if="row.tags">
                <i class="el-icon-collection-tag"></i>
                <el-tag v-for="tag in row.tags.split('|')" :key="tag" size="mini" type="warning"  effect="dark" style="margin-right: 5px;" >
                  {{tag}}
                </el-tag>
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" v-if="operates" v-model="operates">
          <template slot-scope="{ row }">
            <el-badge is-dot v-if="row.notice"></el-badge>
            <el-button
              v-for="item in operates"
              type="text"
              @click="onOperateClick(row, item)"
              :key="item.label"
            >{{ item.label }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        layout="total, prev, slot, next, jumper"
        :current-page="pageNo"
        :page-size="pageSize"
        :page-count="pageCount"
        :total="pageTotal"
        prev-text="上一页"
        next-text="下一页"
        @current-change="onPageChange"
      >
        <span>{{ pageNo }}/{{ pageCount }}</span>
      </el-pagination>
    </div>

    <div class="export-dialog">
      <el-dialog title="数据导出" :visible.sync="dialogExportVisible" center width="50%">
        <el-form size="small" label-width="120px">
          <el-form-item label="下单时间">
            <el-date-picker
              v-model="exportCreateDate"
              type="datetimerange"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="处理完成时间">
            <el-date-picker
              v-model="exportProcessDate"
              type="datetimerange"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right">
            </el-date-picker>
          </el-form-item>
<!--
          <el-form-item label="患者支付状态">
            <el-radio-group v-model="payStatus">
              <el-radio label="">全部</el-radio>
              <el-radio label="0">未支付</el-radio>
              <el-radio label="1">已支付</el-radio>
              <el-radio label="2">已退款</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="患者支付时间" v-if="payStatus==1">
            <el-date-picker
              v-model="exportPayDate"
              type="datetimerange"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="代理商支付状态">
            <el-radio-group v-model="agentPayStatus">
              <el-radio label="">全部</el-radio>
              <el-radio label="0">未支付</el-radio>
              <el-radio label="1">已支付(余额)</el-radio>
              <el-radio label="3">已支付(代金)</el-radio>
              <el-radio label="2">已退款</el-radio>
            </el-radio-group>
          </el-form-item>
-->          
          <el-form-item label="代理商名称">
            <!--            <el-input v-model="exportAgentName" placeholder="请输入代理商名称"></el-input>-->
            <el-select v-model="exportAgentName" clearable @clear="exportAgentName=''"
                       filterable placeholder="请选择代理商">
              <el-option
                v-for="item in agentList"
                :key="item.userId"
                :label="item.agentName"
                :value="item.agentName">
                <span style="float: left">{{ item.agentName }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.username }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="医院名称">
            <!--            <el-input v-model="exportHospitalName" placeholder="请输入医院名称"></el-input>-->
            <el-select
              v-model="exportHospitalName" filterable remote
              clearable
              @clear="clearByType(0)"
              placeholder="请输入医院名称进行搜索"
              :remote-method="loadHospitalListName"
              @change="selectHospital()"
              :loading="loading">
              <el-option
                v-for="item in hospitalList"
                :key="item.id"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="科室名称">
            <!--            <el-input v-model="exportDepartmentName" placeholder="请输入科室名称"></el-input>-->
            <el-select v-model="exportDepartmentName" clearable
                       @clear="clearByType(1)"
                       @change="selectDepartment" filterable placeholder="请选择科室名称">
              <el-option
                v-for="item in departmentList"
                :key="item.id"
                :label="item.name"
                :value="item.name">
                <span style="float: left">{{ item.name }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="医生姓名">
            <!--            <el-input v-model="exportDoctorName" placeholder="请输入医生姓名"></el-input>-->
            <el-select v-model="exportDoctorName" clearable
                       @clear="exportDoctorName=''"
                       filterable placeholder="请选择医生姓名">
              <el-option
                v-for="item in doctorList"
                :key="item.id"
                :label="item.name"
                :value="item.name">
                <span style="float: left">{{ item.name }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="导出类型">
            <el-radio-group v-model="exportType" @change="exportTypeChange">
              <el-radio label="0">标注导出</el-radio>
              <el-radio label="1">销售导出</el-radio>
              <el-radio label="9">全部</el-radio>
              <el-radio label="10">自定义</el-radio>
            </el-radio-group>
          </el-form-item> -->
          <!-- <el-form-item label="全部列">
            <el-checkbox-group v-model="exportCheckedCol">
              <el-checkbox v-for="(item, index) in exportAllCol" :label="index" :key="index" style="margin-right: 64px;">{{ item }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item> -->
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogExportVisible=false">取 消</el-button>
          <el-button type="primary" @click="handleExport">导出</el-button>
        </div>
      </el-dialog>
    </div>

    <!--  订单操作记录 -->
    <el-drawer :visible.sync="taskActivity.show" :title="taskActivity.title + ' ' + taskActivity.orderNumber" direction="rtl" custom-class="detailDrawer" size="60%">
      <el-table stripe :data="taskActivity.records" >
        <el-table-column prop="createTime" label="时间" width="180">
        </el-table-column>
        <el-table-column prop="operatorName" label="操作人" width="160">
        </el-table-column>
        <el-table-column prop="title" label="操作" width="200">
        </el-table-column>
        <el-table-column prop="detail" label="详情">
          <template slot-scope="scope">
            {{scope.row.content}}
            <span v-if="scope.row.content && scope.row.detail">|</span>
            {{scope.row.detail}}
          </template>
        </el-table-column>
      </el-table>
    </el-drawer>
  </div>
</template>
<script>
import * as R from 'ramda';
import {mapState} from 'vuex';
import {task as taskApi} from '@/api';
import tip from '@/utils/tip';
import {isAdmin, isAgent, isCaptain, isWorker, isDoc, msToSecond} from '@/utils';

export default {
  name: 'OrderSearch',
  data() {
    return {
      orderFilter: [],
      orderTable: [],
      form: {
        diseaseId: []
      },
      pageSize: 15,
      pageCount: 0,
      pageNo: 1,
      pageTotal: 0,
      tableData: [],
      sortType: 1,
      // options
      options: {
        diseaseNamesOptions: [],
        itemNamesOptions: [],
        invoiceOptions: [],
      },
      taskActivity: {
        show: false,
        title: '',
        orderNumber: '',
        records: []
      },
      showExport: false,
      dialogExportVisible: false,
      agentList: [],
      hospitalList: [],
      departmentList: [],
      doctorList: [],
      loading: false,
      exportCreateDate: '',
      exportProcessDate: '',
      exportPayDate: '',
      exportAgentName: '',
      exportHospitalName: '',
      exportDepartmentName: '',
      exportDoctorName: '',
      exportType: '9',
      payStatus: '',
      agentPayStatus: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      exportAllCol: ['订单号', '患者姓名', '患者ID', '医院', '科室', '医生', '代理商信息', '是否发票', '提交时间', '开始时间', '完成时间', '订单总用时', '患者支付状态', '患者支付时间', '患者支付金额', '代理商支付状态', '代理商支付时间', '代理商支付金额', '重建类型', '生产负责组', '生产人员'], // 全部列
      exportCheckedCol: [], // 选中列
      exportLabelCol: ['开始时间', '订单号', '医院', '科室', '患者ID', '患者姓名', '是否收费', '订单总用时', '生产负责组', '生产人员'], // 标注列
      exportSalesCol: ['代理商信息', '订单号', '医院', '科室', '医生', '患者姓名', '患者ID', '提交时间', '完成时间'] // 销售列
    };
  },
  computed: {
    ...mapState('common', ['userInfo']),
    isAdmin() {
      const {role} = this.userInfo;
      return isAdmin(role);
    },
    isCaptain() {
      const {role} = this.userInfo;
      return isCaptain(role);
    },
    isWorker() {
      const {role} = this.userInfo;
      return isWorker(role);
    },
    isDoc() {
      const {role} = this.userInfo;
      return isDoc(role);
    },
    isAgent() {
      const {role} = this.userInfo;
      return isAgent(role);
    },
    operates: {
      get() {
        let operates = this.$route.meta.operates;
        if (!operates) {
          return;
        }
        return operates;
      },
      set(val) {
        this.$route.meta.operates = val;
        return this.$route.meta.operates;
      },
    },
    columText: {
      get() {
        return function(data, col, seg) {
          return (col.filter && col.filter(data, seg)) || data[col.prop];
        };
      }
    }
  },
  methods: {
    getOptions() {
      // 加载 重建类型数据
      taskApi.reconData().then((res) => {
        if (res.code === 10000) {
          this.options.itemNamesOptions = R.map(item => ({
            label: item.name,
            value: item.id,
          }), res.data);
        }
      });

      // 加载 病种
      taskApi.diseaseData().then((res) => {
        if (res.code === 10000) {
          // this.options.diseaseNamesOptions = R.map(item => ({
          //   label: item.name,
          //   value: item.id,
          // }), res.data);
          this.options.diseaseNamesOptions = res.data;
        }
      });
      this.options.invoiceOptions.length = 0;
      this.options.invoiceOptions.push({
        label: '否',
        value: 0
      });
      this.options.invoiceOptions.push({
        label: '是',
        value: 1
      });
      if (!this.isAdmin) {
        if (this.operates.length > 1 && this.operates[1].label === '修改重建组') {
          this.operates = this.operates.splice(1, 1);
        }
      }
      if (!this.isAdmin && !this.isCaptain) {
        if (this.operates.length > 1 && this.operates[1].label === '分配') {
          this.operates.splice(1, 1);
        }
      }
      if (this.isDoc || this.isAgent) {
        if (this.operates.length > 1 && this.operates[1].label === '修改负责人') {
          this.operates.splice(1, 1);
        }
        if (this.operates.length > 1 && this.operates[1].label === '查看模型') {
          this.operates.splice(1, 1);
        }
      }
      if (!this.isAdmin && !this.isCaptain) {
        this.orderTable.forEach(item => {
          // eslint-disable-next-line no-unused-expressions
          item.prop === 'processor' ? item.prop = null : '';
          // eslint-disable-next-line no-unused-expressions
          item.prop === 'processGroup' ? item.prop = null : '';
          // eslint-disable-next-line no-unused-expressions
          item.prop === '_nowTime' ? item.prop = null : '';
        });
      }
    },
    getForm() {
      const {orderFilter} = this.$route.meta;
      const form = {};
      R.forEach(({type, prop, start, end}) => {
        if (type === 'datetimerange') {
          form[`${start}_${end}`] = [];
        } else {
          form[prop] = '';
        }
      }, orderFilter);
      this.form = form;
    },
    onOperateClick(row, item) {
      const {onClick} = item;
      if (onClick) {
        onClick(row, this);
      }
    },
    onClickOrderSn(row) {
      // console.error(this.userInfo);
      if (this.isAdmin || this.isCaptain || this.isWorker) {
        this.fetchTaskActivities(row.id, row.patientName).then(res => {
          this.taskActivity.orderNumber = row.publicOrderId;
          //this.taskActivity.show = true;
        });
      } else {
        this.onOperateClickDefault(row);
      }
    },
    onOperateClickDefault(row) {
      if (this.operates && this.operates[0]) {
        const {onClick} = this.operates[0];
        if (onClick) {
          onClick(row, this);
        }
      }
    },
    onReset() {
      this.getForm();
    },
    onCreated() {
      const {orderFilter, orderTable} = this.$route.meta;
      this.orderFilter = orderFilter;
      this.orderTable = orderTable;
      this.getForm();
      this.getOptions();
      this.query();
      this.exportTypeChange(this.exportType);

      if (this.isAdmin) {
        this.showExport = true;
      }
    },
    onSearch() {
      this.query();
    },
    onPageChange(pageNo) {
      this.query(pageNo);
    },
    async query(pageNo = 1) {
      const {fetchDataName} = this.$route.meta;
      this.pageNo = pageNo;
      const submitForm = {};
      R.forEachObjIndexed((value, key) => {
        if (value === undefined || value === '' || value === null) return;
        const filterItem = R.find(R.propEq('prop', key), this.orderFilter) || {};
        if (/_/.test(key)) { // 是 datetimerange
          if (R.isEmpty(value)) return;
          const [startKey, endKey] = key.split('_');
          const [startValue, endValue] = value;
          submitForm[startKey] = msToSecond(startValue);
          submitForm[endKey] = msToSecond(endValue);
        } else {
          if (key === 'diseaseId') {
            value = R.uniq(String(value).split(','));
            value = R.join(',%', value);
          }
          submitForm[key] = filterItem.dataType === 'number' ? Number(value) : String(value).trim();
        }
      }, this.form);
      submitForm.pageNo = this.pageNo;
      submitForm.pageSize = this.pageSize;
      submitForm.sortType = this.sortType;

      let isEmpty = true;
      const formKeys = R.keys(this.form);
      R.forEach((key) => {
        const value = this.form[key];
        if (
          (R.is(Array, value) && !R.isEmpty(value)) ||
          (R.is(String, value) && (value !== '')) ||
          (R.is(Number, value))
        ) {
          isEmpty = false;
        }
      }, formKeys);
      let rq;
      if (isEmpty) {
        rq = taskApi[fetchDataName];
      } else {
        rq = taskApi['fetchAll'];
        const {status} = this.$route.meta;
        if (!R.isNil(status)) {
          submitForm.status = status;
        }
      }
      const res = await rq(submitForm);
      if (res.code === 10000) {
        const {pageCount, data, count} = res;
        this.pageCount = pageCount;
        this.pageTotal = count;
        this.tableData = data;
      }
    },
    /**
     * 分派负责人
     */
    async onAllotProcessor(id, name) {
      const res = await taskApi.allotProcessor(id, name) || {};
      if (res.code === 10000) {
        tip.success('提交成功');
        this.$router.go(0);
      }
    },
    /**
     * 分派 重建组
     * @param id
     * @param name
     * @returns {Promise<void>}
     */
    async onAllotProcessGroup(id, name) {
      const res = await taskApi.allotProcessGroup(id, name) || {};
      if (res.code === 10000) {
        tip.success('提交成功');
        this.$router.go(0);
      }
    },
    // 打开导出框
    async onExportShow() {
      this.dialogExportVisible = true;
      const res = await taskApi.agentList({pageNo: 1, pageSize: 999});
      if (res.code === 10000) {
        this.agentList = res.data.data;
      } else {
        this.$message.error(res.msg);
      }
      // hospitalListName
    },
    clearByType(type) {
      if (type === 0) {
        this.exportHospitalName = '';
        this.hospitalList = [];
        this.exportDepartmentName = '';
        this.departmentList = [];
        this.exportDoctorName = '';
        this.doctorList = [];
      } else if (type === 1) {
        this.exportDepartmentName = '';
        this.exportDoctorName = '';
        this.doctorList = '';
      } else if (type === 2) {
        this.exportDepartmentName = '';
        this.exportDoctorName = '';
        this.doctorList = '';
      }
    },
    // 输入医院名称 进行搜索
    async loadHospitalListName(query) {
      this.loading = true;
      const res = await taskApi.hospitalListName({name: query, pageNo: 1, pageSize: 20});
      if (res.code === 10000) {
        this.hospitalList = res.data.data;
      } else {
        this.$message.error(res.msg);
      }
      this.loading = false;
    },
    // 选中医院后，加载科室 医生
    async selectHospital() {
      if (!this.exportHospitalName || this.exportHospitalName.length <= 0) {
        return;
      }
      const res = await taskApi.departmentListName({hospital: this.exportHospitalName, pageNo: 1, pageSize: 999});
      if (res.code === 10000) {
        this.departmentList = res.data.data;
      } else {
        this.$message.error(res.msg);
      }
    },
    // 选中 科室后，加载医生
    async selectDepartment() {
      this.doctorList = [];
      this.exportDoctorName = '';
      const dep = this.departmentList.filter(d => d.name === this.exportDepartmentName)[0];
      if (dep) {
        this.doctorList.push({
          id: dep.id,
          name: dep.doctorName
        });
      }
    },
    /**
     * 导出类型 切换
     */
    exportTypeChange(val) {
      let tempArr = [];
      if (val === '10') {
        tempArr = [];
      } else if (val === '9') {
        tempArr = this.exportAllCol;
      } else if (val === '0') {
        tempArr = this.exportLabelCol;
      } else if (val === '1') {
        tempArr = this.exportSalesCol;
      }
      this.exportCheckedCol = [];
      for (let i = 0; i < this.exportAllCol.length; i++) {
        for (let j = 0; j < tempArr.length; j++) {
          if (tempArr[j] === this.exportAllCol[i]) {
            this.exportCheckedCol.push(i);
          }
        }
      }
    },
    /**
     * 执行导出
     */
    async handleExport() {
      if (!this.exportCheckedCol || this.exportCheckedCol.length <= 0) {
        this.$message.error('请至少选择一列');
        return;
      }
      const param = {
        createBegin: this.exportCreateDate[0],
        createEnd: this.exportCreateDate[1],
        finishBegin: (this.exportProcessDate || [])[0],
        finishEnd: (this.exportProcessDate || [])[1],
        patientPayBegin: (this.exportPayDate || [])[0],
        patientPayEnd: (this.exportPayDate || [])[1],
        agentName: this.exportAgentName,
        hospital: this.exportHospitalName,
        department: this.exportDepartmentName,
        doctor: this.exportDoctorName,
        type: this.exportType,
        payStatus: this.payStatus,
        agentPayStatus: this.agentPayStatus,
        col: this.exportCheckedCol.join(',')
      };
      const stream = await taskApi.exportTaskInfo(param) || {};
      this.download(stream);
    },
    download(stream) {
      const blob = new Blob([stream], {type: 'application/vnd.ms-excel'});

      // 前端获取业务码，成功执行正常业务
      const downloadElement = document.createElement('a');
      const href = window.URL.createObjectURL(blob); // 创建下载的链接
      downloadElement.href = href;
      downloadElement.download = new Date().toString(); // 下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); // 点击下载
      document.body.removeChild(downloadElement); // 下载完成移除元素
      window.URL.revokeObjectURL(href); // 释放掉blob对象
      return true;
    },

    columWidth(colName) {
      let widthList = {
        publicOrderId: 280, invoice: 50, doctorName: 100, patientName: 90, departmentName: 110, status: 80, reconIdNames: 120, payStatus: 80, processor: 90, processGroup: 90, examPatientId: 130
      };
      return widthList[colName] || '';
    },
    workerTags(text) {
      let list = [];
      for (let r of text.split('|')) {
        let arr = r.split(':');
        for (let item of list) { // 合并
          if (item.name === arr[1]) {
            item.tip += ',' + arr[0];
            arr = null;
            break;
          }
        }
        if (arr) {
          list.push({tip: arr[0], name: arr[1]});
        }
      }
      return list;
    },
    // 查询订单操作记录
    fetchTaskActivities(taskId, patientName) {
      return taskApi.getActivities(taskId).then(res => {
        if (res.code === 10000) {
          this.taskActivity.title = patientName;
          this.taskActivity.records = res.data;
          this.taskActivity.records.forEach(item => {
            // console.error(item);
            var date = new Date(Date.parse(item.createTime));
            item.createTime = date.toLocaleString('zh-CN', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
          });
          return Promise.resolve(this.taskActivity);
        }
      });
    }

  },
  created() {
    this.onCreated();
  },
  watch: {
    '$route'(to, from) {
      // 路由参数keepCache为false，且当前页面为订单列表页，就重载订单列表
      if (this.$route.meta.orderList && !this.$route.meta.keepCache) {
        this.onCreated();
      }
      this.$route.meta.keepCache = false;
    }
  }
};
</script>
<style lang="scss">
.export-dialog {
  .el-checkbox {
    width: 90px;
    margin-right: 5px;
    margin-left: 10px;
  }
}
</style>
<style lang="scss" scoped>
.el-picker-panel__link-btn.is-plain {
  &.is-disabled {
    background-color: #a0cfff !important;
    border-color: #a0cfff !important;

    &:hover {
      background-color: #a0cfff !important;
      border-color: #a0cfff !important;
    }
  }

  &:hover {
    background-color: #66b1ff !important;
    border-color: #66b1ff !important;
  }

  background-color: #409eff;
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/view/OrderSearch/index.vue